module.exports = __webpack_public_path__ + "static/media/Courage.36ef3e25.webp";